import { apiFetch } from '../../../../services/api';
 
const API_BASE_URL = process.env.REACT_APP_API_URL || '';
 
export type FeedbackFilter = 'all' | 'like' | 'dislike';
 
export interface FeedbackSummary {
  total_likes: number;
  total_dislikes: number;
  like_rate: number;
}
 
export interface FeedbackDailyStat {
  date: string;
  likes: number;
  dislikes: number;
}
 
export interface FeedbackMessageItem {
  message_id: string;
  question_timestamp: string;
  username: string;
  user_id: number;
  question: string;
  answer: string;
  user_feedback: 'like' | 'dislike';
}
 
export interface FeedbackAnalyticsResponse {
  summary: FeedbackSummary;
  daily_stats: FeedbackDailyStat[];
  messages: FeedbackMessageItem[];
}
 
export interface GetFeedbackAnalyticsParams {
  startDate: string;
  endDate: string;
  feedback?: FeedbackFilter;
  limit?: number;
  signal?: AbortSignal;
}
 
export const getFeedbackAnalytics = async (
  params: GetFeedbackAnalyticsParams
): Promise<FeedbackAnalyticsResponse> => {
  const { startDate, endDate, feedback = 'all', limit = 200, signal } = params;
 
  const query = new URLSearchParams({
    start_date: startDate,
    end_date:   endDate,
    feedback,
    limit:      limit.toString(),
  });
 
  const response = await apiFetch(
    `${API_BASE_URL}/api/v1/chats/analytics/feedback/?${query}`,
    { signal },
    true
  );
 
  if (!response.ok) {
    throw new Error(`Failed to fetch feedback analytics: ${response.status}`);
  }
 
  return response.json();
};
 